<template lang="pug">
div
  el-row.container(type="flex")
    h3.title Filtros
    el-row.filter-row
      el-col
        p.label Município:
        el-select(
          clearable,
          filterable,
          multiple,
          default-first-option=false,
          name="municipio",
          v-model="dados.municipios",
        )
          el-option(
            v-for="item in municipios",
            :key="item.nome",
            :label="item.nome",
            :value="item.nome",
          )
      el-col
        p.label Data de cadastro:
        el-date-picker.full-width.input.date(
          type="daterange",
          start-placeholder="Data inicial",
          end-placeholder="Data Final",
          format="dd/MM/yyyy",
          name='dataCadastro',
          v-model="dados.periodo",
          :style='{"width": "inherit"}'
        )
      el-col
        p.label Situação:
        el-select(
          clearable,
          filterable,
          default-first-option=false,
          name="status",
          collapse-tags,
          v-model="dados.status",
        )
          el-option(
            v-for="item in situacao",
            :key="item.nome",
            :label="item.nome",
            :value="item.id",
          )
    el-row.filter-row
      el-col
        p.label Perfil:
        el-select(
          clearable,
          filterable,
          default-first-option=false,
          name="perfil",
          collapse-tags,
          v-model="dados.perfil",
        )
          el-option(
            v-for="item in perfis",
            :key="item.codigo",
            :label="item.nome",
            :value="item.codigo",
          )
      el-col
        p.label Setor:
        el-select(
          clearable,
          filterable,
          default-first-option=false,
          name="setor",
          collapse-tags,
          v-model="dados.setor",
        )
          el-option(
            v-for="item in setores",
            :key="item",
            :label="item",
            :value="item",
          )
      el-col(:style="[showNumeroProcesso ? {'visibility': 'visible'} : {'visibility': 'hidden'}]")
        p.label Número do processo
        el-input(
          v-model="dados.numeroProcesso"
        )
    el-row.button-row
      span.limpar(@click="limpar") Limpar
      el-button(type="primary", @click="filtrar")
        | Filtrar
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import parametros from '../constants/tipoParametros'

export default {

  data () {
    return {
      dados: _.cloneDeep(parametros.FILTRO_EMPTY),
      municipios: [],
      setores: parametros.SETORES.TODOS,
      perfis: parametros.PERFIS,
      situacao: parametros.STATUS
    }
  },

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    showNumeroProcesso: {
      type: Boolean,
      default: false
    },
    estado: {
      type: String,
      required: false,
      default: 'PA'
    }
  },

  methods: {
    ...mapActions({
      getMunicipiosByUf: 'municipios/findMunicipiosByUf'
    }),

    limpar () {
      this.dados = _.cloneDeep(parametros.FILTRO_EMPTY)
      this.$emit('limpar')
    },

    filtrar () {
      if (this.dados.periodo) {
        this.dados.periodo[1].setHours(20)
        this.dados.periodo[1].setMinutes(59)
      }
      this.$emit('filtrar', this.dados)
    }
  },

  async created () {
    this.municipios = await this.getMunicipiosByUf(this.estado)
  },

  watch: {
    'dados.perfil': function (val, oldVal) {
      if (val) {
        this.setores = parametros.SETORES[val]
        this.dados.setor = this.setores[0]
      } else {
        this.setores = parametros.SETORES.TODOS
      }
    }
  }
}

</script>

<style scoped lang="scss">
@import '../../../../assets/styles/element-variables.scss';
.container {
  background-color: white;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  padding: 0.2% 1.5%;
  padding-bottom: 1.5%;
  gap: 4%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 3%;
}

.filter-row {
  display: flex;
  gap: 4%;
}

.limpar {
  margin-right: 20px;
  color: $--color-primary;
  cursor: pointer;
  &:hover {
    font-weight: bold;
  }
}
.icon {
  margin-right: 7px;
}
.el-select {
  width: 100%;
}
.label {
  margin: 0;
  padding: 12px 0 8px 0px;
}
.button-row {
  margin-top: 10px;
  text-align: right;
}
.right {
  float: right;
  cursor: pointer;
  margin: 10px 0px;
}
.pagination {
    text-align: center;
}
.full-width {
    width: -webkit-fill-available;
}

.busca {
  padding: 12px 0 8px 0px;
  text-align: left;
  color: $--color-primary !important;
  cursor: pointer;
  &:hover {
    font-weight: bold;
  }
}

.el-radio-group /deep/ .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
  box-shadow: none;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

@media (max-width: 780px) {
  .filter-row {
    flex-direction: column;
  }
}

@media only screen and (max-width: 1256px) {
}

.icon-info {
  font-size: 25;
  margin: 0 0 10px 5px;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/relatorios/components/FiltroRelatorios.vue